import React, {useEffect, useState} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import BaseModal from "./BaseModal";
import activeModalState from "../../state/ui/activeModalState";
import FormControl from "../../components/FormControl";
import playerState from "../../state/ui/playerState";
import { useTranslation } from "react-i18next";
import boothModeState from "../../state/ui/boothModeState";
import {firebaseClaimsState, connectedState, firebaseUidState} from "../../state/firebaseState";


export default function QualityModal() {
  const {t} = useTranslation(['lounge', 'booth'])
  const [activeModal, setShowModal] = useRecoilState(activeModalState);
  const player = useRecoilValue(playerState);

  const [disabled, setDisabled] = useState(false);
  const [value, setValue] = useState();
  const [trackValue, setTrackValue] = useState();

  const [boothMode, setBoothMode] = useRecoilState(boothModeState);
  const firebaseClaims = useRecoilValue(firebaseClaimsState);

  useEffect(() => {
    setValue(player.selectedQuality || '');
  },[player.selectedQuality]);

  useEffect(() => {
    setTrackValue(player.selectedTrack || '');
  },[player.selectedTrack]);

  return (
    <BaseModal show={activeModal === 'quality'} title={t('lounge:video-quality')}>
      <div className="w-full">
        {/* <FormControl.Checkbox
            label="1080p"
        /> */}
        {window?.SpacePlayer?.setQuality && window?.SpacePlayer?.setTrack &&
          <>
            <FormControl.Select
              light
              label={t('lounge:video-quality')}
              className="mb-2"
              options={player.qualities ? player.qualities.map(item => ({value: item.id, label: item.label})) : []}
              onChange={(e) => {
                setValue(e.target.value);
              }}
              value={value}
              disabled={disabled}
            />
            <FormControl.Select
              light
              label={t('lounge:video-captions')}
              className="mb-2"
              options={player.tracks ? player.tracks.map(item => ({value: item.id, label: item.label})) : []}
              onChange={(e) => {
                setTrackValue(e.target.value);
              }}
              value={trackValue}
              disabled={disabled}
            />
            <button
              type={'submit'}
              onClick={async () => {
                setDisabled(true);
                if(value != player.selectedQuality && window.SpacePlayer?.setQuality) {
                  await window.SpacePlayer.setQuality(value)
                }
                if(trackValue != player.selectedTrack && window.SpacePlayer?.setTrack) {
                  await window.SpacePlayer.setTrack(trackValue)
                }
                setDisabled(false);
                setShowModal('');
              }}
              disabled={disabled}
              className="btn-primary">
                {t('lounge:update')}
            </button>
          </>
        }

        {firebaseClaims?.isAdmin && window?.SpacePlayer?.setQuality && window?.SpacePlayer?.setTrack &&
          <hr className="w-full border-t border-gray-200 my-5"/>
        }

        {(firebaseClaims?.isAdmin) &&
          <>
            <button className="btn-primary" onClick={()=>setBoothMode((prev)=>!prev)}>
              {boothMode ? t('booth:quit-control-booth') : t('booth:enter-control-booth')}
            </button>
          </>
        }
      </div>
    </BaseModal>
  )
}
